import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQSection = () => {
  const [ref, inView] = useInView({ threshold: 0.2, triggerOnce: true });

  const faqs = [
    {
      question: '¿En qué se diferencia Kompa de un crédito tradicional?',
      answer: 'Kompa no es un crédito tradicional. Es un sistema de ahorro con propósito donde tú construyes tu meta mes a mes. No cobramos intereses como los bancos. En Ahorro Total, al completar tu plan, Kompa te regresa hasta el 15% del valor. En Ahorra entre Kompas, puedes recibir tu meta cuando llegues al 65% si eres seleccionado.',
    },
    {
      question: '¿Qué significa que Kompa me regresa hasta el 15% del valor de mi plan?',
      answer: 'En la modalidad de Ahorro Total, cuando completas el 100% de tu plan aportando mensualmente, Kompa te devuelve hasta el 15% del valor total. Por ejemplo, si tu plan es de €3.000 a 36 meses, al completarlo recibes €450 de vuelta. Es nuestro reconocimiento a tu constancia.',
    },
    {
      question: '¿Qué pasa si dejo de aportar uno o varios meses?',
      answer: 'Entendemos que pueden surgir imprevistos. Si dejas de aportar, tu plan se pausa pero no lo pierdes. Tu progreso queda guardado y puedes retomar cuando estés listo. Mientras más constante seas, más rápido lograrás tu meta. Los KOMPAS están aquí para acompañarte.',
    },
    {
      question: '¿Qué tan seguro es mi dinero?',
      answer: 'Tu dinero está respaldado y protegido. Los fondos están separados en cuentas específicas. Realizamos auditorías externas periódicas y trabajamos con bancos, aseguradoras y casas de bolsa reconocidas. Todos nuestros procesos son automáticos y transparentes.',
    },
    {
      question: '¿Qué son los grupos entre kompas?',
      answer: 'En la modalidad Ahorra entre Kompas, cuando llegas al 65% de tu meta, entras en un grupo con otros kompas. Cada mes, el sistema selecciona automáticamente a quienes tienen mayor porcentaje de avance para entregarles su meta antes del 100%. Luego, continúan aportando hasta completar su plan.',
    },
  ];

  return (
    <section id="faq" ref={ref} className="relative py-32 bg-gradient-to-br from-white to-yellow-50 overflow-hidden">
      {/* Kompaisito con nube de diálogo */}
      <div className="absolute bottom-10 right-10 hidden lg:block">
        <motion.div
          animate={{
            y: [0, -15, 0],
          }}
          transition={{ duration: 4, repeat: Infinity }}
          className="relative"
        >
          {/* Nube de diálogo al lado izquierdo del Kompaisito - a la altura de la cabeza */}
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={inView ? { opacity: 1, scale: 1 } : {}}
            transition={{ delay: 0.5, type: "spring" }}
            className="absolute top-12 -left-36 z-10"
          >
            <div className="bg-white rounded-2xl px-6 py-3 shadow-2xl border-4 border-[#fbb040] relative whitespace-nowrap">
              <p className="text-black font-black text-lg">Atención 24/7</p>
              {/* Triángulo apuntando hacia la derecha */}
              <div className="absolute top-1/2 -translate-y-1/2 -right-3 w-0 h-0 border-t-[12px] border-t-transparent border-b-[12px] border-b-transparent border-l-[12px] border-l-[#fbb040]"></div>
            </div>
          </motion.div>
          
          {/* Kompaisito sin fondo */}
          <img
            src="https://customer-assets.emergentagent.com/job_kompa-landing/artifacts/nndf0ac2_edited-photo.png"
            alt="Kompaisito"
            className="w-72 h-72 drop-shadow-2xl"
          />
        </motion.div>
      </div>
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <h2 className="text-4xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-900 to-orange-500 mb-6 leading-tight pb-4">
            Preguntas frecuentes
          </h2>
          <p className="text-xl text-gray-600">
            Resolvemos tus dudas
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-gradient-to-br from-gray-50 to-white rounded-2xl px-6 border-2 border-gray-200 hover:border-orange-400 transition-all duration-300 shadow-lg"
              >
                <AccordionTrigger className="text-left font-bold text-lg text-blue-900 hover:text-orange-500">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-700 leading-relaxed text-lg">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;
